import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_NCI } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const CanopyCoverExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='canopy-cover-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.forest.explainers.canopyCover.howDoMeasureThis.headline')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={t('shared.ncaDetail.details.forest.explainers.canopyCover.howDoMeasureThis.canopyCoverBody')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_NCI} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
